import { NominalDecimal } from "@goodfill/nominal/decimal";
import Decimal from "decimal.js";

// Todo: rename Amount to Money
export type Amount = NominalDecimal<"Amount">;
export const asAmount = (value: Decimal) => value as unknown as Amount;
